export default __webpack_public_path__ + "static/media/no-profile-img.e67b7663.png";